import React from 'react';
import {
  ManualDevelopmentSection,
  SectionHeading,
  ManualDevelopmentRows,
  ManualDevelopmentRow,
  DevelopmentNumber,
} from './Development.styles';

const Development = () => {
  return (
    <ManualDevelopmentSection>
      <SectionHeading>
        <p className="eyebrowHeader">Built Around Your Organization</p>

        <h2>More Than a Generic Safety Manual</h2>

        <p>
          Every workplace is different. Your safety documentation should make
          sense for the work your employees actually perform, the procedures
          they follow, and the responsibilities within your organization.
        </p>
      </SectionHeading>

      <ManualDevelopmentRows>
        <ManualDevelopmentRow>
          <DevelopmentNumber>01</DevelopmentNumber>

          <div>
            <h3>Your Workplace</h3>
            <p>
              The manual can be developed with your company&apos;s operations,
              environment, and day-to-day work in mind.
            </p>
          </div>
        </ManualDevelopmentRow>

        <ManualDevelopmentRow>
          <DevelopmentNumber>02</DevelopmentNumber>

          <div>
            <h3>Your Procedures</h3>
            <p>
              Safety documentation can reflect the procedures and expectations
              your organization needs employees to follow.
            </p>
          </div>
        </ManualDevelopmentRow>

        <ManualDevelopmentRow>
          <DevelopmentNumber>03</DevelopmentNumber>

          <div>
            <h3>Your Safety Program</h3>
            <p>
              Bring important policies, procedures, and workplace safety
              information together into one organized resource.
            </p>
          </div>
        </ManualDevelopmentRow>
      </ManualDevelopmentRows>
    </ManualDevelopmentSection>
  );
};

export default Development;
